import ModeratorNotes from './ModeratorNotes';
import ModeratorNotesCreate from './ModeratorNotesCreate';
import ModeratorNotesPage from './ModeratorNotesPage';
import NoteListItem from './NoteListItem';

export const components = {
  ModeratorNotes,
  ModeratorNotesCreate,
  ModeratorNotesPage,
  NoteListItem,
};
